import DeclineLessonsRequestModelBase from '../_generated/modelBases/decline-lessons-request-model-base';

export default class DeclineLessonsRequestModel extends DeclineLessonsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
